import React from 'react';

function SummaryStrip({ metrics, darkMode: d }) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '16px',
        marginBottom: '24px',
      }}
    >
      {metrics.map((metric, idx) => (
        <div
          key={idx}
          style={{
            background: d ? 'rgba(255,255,255,0.04)' : '#fff',
            border: `1px solid ${d ? 'rgba(255,255,255,0.08)' : '#e2e8f0'}`,
            borderRadius: '12px',
            padding: '20px 16px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            transition: 'all 0.2s ease',
            cursor: 'default',
            boxShadow: d
              ? '0 2px 8px rgba(0,0,0,0.2)'
              : '0 1px 3px rgba(15,37,87,0.08)',
          }}
          onMouseEnter={(e) => {
            if (!d) {
              e.currentTarget.style.borderColor = metric.color;
              e.currentTarget.style.boxShadow = `0 4px 12px ${metric.color}20`;
            }
          }}
          onMouseLeave={(e) => {
            if (!d) {
              e.currentTarget.style.borderColor = '#e2e8f0';
              e.currentTarget.style.boxShadow = '0 1px 3px rgba(15,37,87,0.08)';
            }
          }}
        >
          <div
            style={{
              width: '44px',
              height: '44px',
              borderRadius: '8px',
              background: `${metric.color}20`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '20px',
              flexShrink: 0,
            }}
          >
            {metric.icon}
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div
              style={{
                fontSize: '12px',
                fontWeight: '600',
                color: d ? '#94a3b8' : '#64748b',
                letterSpacing: '0.5px',
                marginBottom: '4px',
                textTransform: 'uppercase',
              }}
            >
              {metric.label}
            </div>
            <div
              style={{
                fontSize: '28px',
                fontWeight: '900',
                color: metric.color,
                lineHeight: '1',
              }}
            >
              {metric.value}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default SummaryStrip;
